import { defaultHighLightArray } from './const';
export interface IParseTextResult {
    text: string; // 显示的文案
    onClick?: () => void; // 点击事件
    textStyle?: any; // 文案样式
}

/**
 * 解析文案，返回解析后的结果，展示给用户的文案信息
 * @param text
 */
export function parseText(text: string): Array<IParseTextResult> {
    const combinePattern = new RegExp(
        defaultHighLightArray.map(item => item.pattern.source).join('|'),
        'g'
    );
    let result: any[] = [];
    let lastIndex = 0;
    let match;

    while ((match = combinePattern.exec(text)) !== null) {
        // 添加前面的纯文本
        if (match.index > lastIndex) {
            result.push({
                text: text.substring(lastIndex, match.index),
            });
        }
        defaultHighLightArray.map(item => {
            const { matchContentIndex, getParseResult } = item;
            // 添加匹配到的内容
            if (match[matchContentIndex]) {
                // 匹配到用户信息
                result.push(getParseResult(match));
            }
        });

        lastIndex = combinePattern.lastIndex;
    }

    // 添加最后的纯文本
    if (lastIndex < text.length) {
        result.push({
            text: text.substring(lastIndex),
        });
    }
    return result;
}

// 获取解析后的结果，只保留匹配到的，多余的文案不保留
// 获取的数据结构，根据defaultHighLightArray.getParseResult.data 的返回值构造
export function getParseResult(text: string) {
    const combinePattern = new RegExp(
        defaultHighLightArray.map(item => item.pattern.source).join('|'),
        'g'
    );
    let result: Array<any> = [];
    let match;
    while ((match = combinePattern.exec(text)) !== null) {
        defaultHighLightArray.map(item => {
            const { matchContentIndex, getParseResult } = item;
            // 添加匹配到的内容
            if (match[matchContentIndex]) {
                // 匹配到用户信息
                result.push(getParseResult(match).data);
            }
        });
    }
    return result;
}

export function unparseRichText(text: string) {
    const combinePattern = new RegExp(
        defaultHighLightArray.map(item => item.pattern.source).join('|'),
        'g'
    );
    let match;
    let result: any[] = [];
    let lastIndex = 0;
    while ((match = combinePattern.exec(text)) !== null) {
        // 添加前面的纯文本
        if (match.index > lastIndex) {
            result.push(text.substring(lastIndex, match.index));
            // result.push({
            //     text: text.substring(lastIndex, match.index),
            // });
        }
        defaultHighLightArray.map(item => {
            const { matchContentIndex, getParseResult, charStr } = item;
            // 添加匹配到的内容
            if (match[matchContentIndex]) {
                const unparseText = `${charStr}${match[matchContentIndex]} `;
                // 匹配到用户信息
                result.push(unparseText);
            }
        });

        lastIndex = combinePattern.lastIndex;
    }

    return result.join('');
}
